import "./notification.scss"

interface INotification {
    hasNotification: boolean
}

const Notification = ({hasNotification}: INotification) => {
    return (
        <div className={hasNotification ? "Notification hasNotification" : "Notification"}>
            <img src={require("../../assets/images/icons/Notification.svg").default} alt=""
                 className="img-fluid Notification-Image align-middle"/>
        </div>
    );
}

export default Notification